module.exports = __webpack_public_path__ + "img/logo.177bbf40.png";